import { Close } from "@mui/icons-material";
import { type FC, useState } from "react";

import { useDocumentVersioningDialog } from "~/components/git/GitHistoryDialog/useDocumentVersioningDialog";
import { useRouteParams } from "~/data/route";
import { useGitConfigActor } from "~/state";
import { Button, IconButton } from "~/ui/Button";

export const Announcement: FC = () => {
	//
	// Someday we will use this for things other than telling the user to configure git. Today, it
	// just tells users to configure git.
	//

	const { workspaceName, documentId } = useRouteParams();
	const config = useGitConfigActor();
	const dialogState = useDocumentVersioningDialog({ workspaceName, documentId });

	const [dismissed, setDismissed] = useState(false);

	const userNotConfigured =
		!config.isLoading && (!config.data?.["user.name"] || !config.data?.["user.email"]);

	const show = userNotConfigured && !dismissed;

	return (
		show && (
			<div className="relative flex flex-col gap-2 bg-primary-raised rounded-lg p-3.5 border shadow-md m-2 text-xs">
				<div className="absolute top-2 right-2">
					<IconButton
						preset="quaternary"
						size="xs"
						icon={<Close />}
						label="Close"
						elevation="flat"
						borderRadius="default"
						onClick={() => setDismissed(true)}
					/>
				</div>
				<div className="font-medium">Configure git user</div>
				<div>
					Setting local git user information determines how you appear in the document
					commit history.
				</div>
				<Button
					preset="primary"
					size="xs"
					className="mt-1"
					elevation="flat"
					onClick={() => dialogState.setSelection("settings")}
				>
					Add git user information
				</Button>
			</div>
		)
	);
};
